import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const BUYERS = [{
  name: 'María L.',
  city: 'Córdoba'
}, {
  name: 'Luciana S.',
  city: 'CABA'
}, {
  name: 'Florencia M.',
  city: 'Rosario'
}, {
  name: 'Julieta R.',
  city: 'Mendoza'
}, {
  name: 'Camila P.',
  city: 'La Plata'
}, {
  name: 'Valentina G.',
  city: 'Tucumán'
}, {
  name: 'Ana Paula D.',
  city: 'Salta'
}, {
  name: 'Sofía V.',
  city: 'Mar del Plata'
}, {
  name: 'Martina C.',
  city: 'Neuquén'
}, {
  name: 'Agustina B.',
  city: 'San Juan'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showRandomPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomPopup = () => {
    const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
    const randomTime = Math.floor(Math.random() * 12) + 1; // 1 to 12 minutes ago
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (between 15 and 30 seconds)
      const nextDelay = Math.floor(Math.random() * 15000) + 15000;
      setTimeout(showRandomPopup, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-191">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-24 left-4 md:bottom-6 md:left-6 z-50 bg-white rounded-lg shadow-2xl border border-gray-100 p-3 pr-8 max-w-[300px] flex items-start gap-3" data-id="element-192">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-193">
            <XIcon className="w-4 h-4" data-id="element-194" />
          </button>

          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-195">
            <CheckIcon className="w-4 h-4 text-green-600" data-id="element-196" />
          </div>

          <div data-id="element-197">
            <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-198">
              <span className="font-bold" data-id="element-199">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city} compró el Mega Pack
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-200">
              hace {timeAgo} {timeAgo === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}